const localStorageSetItem = (key: string, value: any) => {
  if (typeof value === "object") {
    value = JSON.stringify(value);
  }

  localStorage.setItem(key, value);
}

const localStorageGetItem = (key: string) => {
  const value = localStorage.getItem(key);
  if (value == null) {
    return null;
  }

  let result: any;
  if (value.startsWith("{") || value.startsWith("[")) {
    result = JSON.parse(value);
  }
  else
  {
    result=value;
  }

  return result;
}

const langKey="lang_storage";

export {
  localStorageSetItem,
  localStorageGetItem,
  langKey
}
